import React from 'react';
import { Typography } from '@material-ui/core';

interface Component {
  label_display: any;
  label: any;
}

interface IMSFormAccordionHeadingProps {
  component: Component;
}

const IMSFormAccordionHeading: React.FC<IMSFormAccordionHeadingProps> = ({ component }) => {
  return (
    <h3 style={{ color: '#4f2682' }}>
      {component.label_display || component.label}
    </h3>
  );
};

export default IMSFormAccordionHeading;
